<template>
    <div class="main-wrapper scroll-y custom-scrollbar view-notifications">

        <page-title :title="'Powiadomienia'" :back="true"></page-title>

        <div v-if="notifications.length">
            <div v-for="(item,index) in notifications" :key="item.slug">
                <item-notification
                        :index="index"
                        :id="item.id"
                        :slug="item.slug"
                        :title="item.title"
                        :body="item.body"
                        :thumbnail="item.thumbnail"
                        :isRead="item.isRead"
                        :hasRedirect="item.hasRedirect"
                        :redirectRoute="item.redirectRoute"
                        :redirectSlug="item.redirectSlug">
                </item-notification>
            </div>
        </div>
        <div v-else>
            <p class="text-center mt-20">Brak powiadomień</p>
        </div>

    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import PageTitle from '@/components/PageTitle.vue';
    import ItemNotification from '@/items/ItemNotification';

    export default {
        name: 'UserNotifications',
        components: {PageTitle, ItemNotification},
        computed: {
            ...mapState({
                loading: state => state.profile.loading,
                notifications: state => state.profile.notifications
            })
        },
        mounted(){
            this.$store.dispatch('profile/PROFILE_NOTIFICATIONS_REQUEST');
        }
    }
</script>